module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/supplier-dialog/supplier-dialog.component.scss
// module id = 1510
// module chunks = 0